import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
	dialogActions: {
		justifyContent: 'flex-start'
	}
}))

const CancelDeleteVisitDialog = (props) => {
	const classes = useStyles()
	let { toDelete, isShown, setIsShown, confirmDeletion } = props

	const width = toDelete ? '448px' : '460px'
	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onClose={() => setIsShown(false)}
			PaperProps={{
				style: {
					minWidth: width,
					maxWidth: width,
					width: width
				}
			}}>
			<DialogTitle
				style={{
					marginBottom: 24
				}}>
				{`${toDelete ? `DELETE` : `CANCEL`} APPOINTMENT`}
			</DialogTitle>
			<DialogContent>
				<Typography
					variant="body2"
					style={{
						marginBottom: 24
					}}>
					This action cannot be undone.
				</Typography>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button variant="contained" onClick={() => confirmDeletion()} color="secondary">
					{`CONFIRM ${toDelete ? `DELETION` : `CANCELLATION`}`}
				</Button>
				<Button variant="outlined" onClick={() => setIsShown(false)} color="secondary">
					GO BACK
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default CancelDeleteVisitDialog
